import React from 'react'
import { Input, Fade } from '@chakra-ui/react'

export const SearchBar = ({
  isExpanded,
  isDesktop,
  accentColor,
  dictionary,
  setDebouncedTerm,
  fontFamily,
  skin
}) => {
  return (
    <Fade in={isExpanded}>
      <Input
        size={isDesktop === 'desktop' ? 'md' : 'sm'}
        borderColor={skin === 'FINSUS' ? '#23223F': accentColor}
        color='brand.secondaryDark'
        placeholder={dictionary.HEADER.searchBar}
        _placeholder={{
          color: '#001B69'
        }}
        borderWidth='2px'
        borderRadius='4px'
        shadow='xl'
        _hover={{
          bg: 'brand.bg',
          borderColor:  skin === 'FINSUS' ? '#23223F' : accentColor
        }}
        w='280px'
        focusBorderColor={skin === 'FINSUS' ? '#23223F' : accentColor}
        autoFocus
        onChange={(e) => setDebouncedTerm(e.target.value)}
        // onKeyDown={handleKeyDown}
        fontFamily={fontFamily}
        fontWeight='500'
      />
    </Fade>
  )
}
